import { useState, useCallback } from 'react';
import type { AxiosResponse } from 'axios';

function useRequest<TData = any, TParams = any>(
  requestFunc: (params: TParams, extraParams?: any) => Promise<AxiosResponse<TData>>,
) {
  const [requestData, setRequestData] = useState<TData | null>(null);
  const [error, setError] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);

  const doRequest = useCallback(
    async (params: TParams, extraParams?: any) => {
      setLoading(true);
      setError(null);
      try {
        const { data } = await requestFunc(params, extraParams);
        setRequestData(data);
        return data;
      } catch (errorRequest: any) {
        setRequestData(null);
        setError(errorRequest?.response || errorRequest);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [requestFunc],
  );

  return {
    doRequest,
    isLoading,
    error,
    data: requestData,
  };
}

export default useRequest;
